import { Box, Heading, Text } from '@wix/design-system';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './Tool.scss';
const TOOLS_MARGIN_BOTTOM = 45;
const HEADER_HEIGHT = 58;
export const Tool = _ref => {
  let titleKey = _ref.titleKey,
    descriptionKey = _ref.descriptionKey,
    backgroundColor = _ref.backgroundColor,
    _ref$light = _ref.light,
    light = _ref$light === void 0 ? false : _ref$light,
    illustration = _ref.illustration,
    index = _ref.index,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const stickyTop = index === 0 ? 0 : index * TOOLS_MARGIN_BOTTOM + HEADER_HEIGHT;
  const Wrapper = index === 0 ? FirstToolWrapper : React.Fragment;
  return /*#__PURE__*/React.createElement(Box, {
    top: stickyTop,
    direction: "vertical",
    width: "100%",
    position: "sticky",
    marginBottom: "26px"
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Box, {
    gap: isMobile ? '60px' : 'SP4',
    align: isMobile ? undefined : 'space-between',
    width: "100%",
    backgroundColor: backgroundColor,
    height: "400px",
    borderRadius: "12px",
    padding: isMobile ? '30px 18px' : '60px SP10',
    verticalAlign: isMobile ? 'top' : 'middle',
    boxSizing: "border-box",
    direction: isMobile ? 'vertical' : 'horizontal'
  }, /*#__PURE__*/React.createElement(Box, {
    maxWidth: "340px",
    gap: isMobile ? 'SP3' : 'SP6',
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    light: light,
    className: s.toolTitle
  }, t(titleKey)), /*#__PURE__*/React.createElement(Text, {
    light: light,
    className: s.toolDescription
  }, t(descriptionKey))), isMobile ? /*#__PURE__*/React.createElement(Box, {
    className: s.mobileIllustration
  }, illustration) : illustration)));
};
const FirstToolWrapper = _ref2 => {
  let children = _ref2.children;
  const _DomainSearchGateModu2 = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu2.t;
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    gap: "SP7",
    direction: "vertical",
    align: "center"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.sectionTitle
  }, t('domain_search_gate.domain_gate.add_ons_section.header')), children);
};
//# sourceMappingURL=Tool.js.map